export default __webpack_public_path__ + "static/logo-wall-mobile-9d92b9e7705094374b2dd51106d21c08.png";